<h1 class="text-center">Questions</h1>

<fgbcl-errors></fgbcl-errors>
<div *ngIf="registrationUserQuestions$ | async as registrationUserQuestions; else loading">
  <h3>Questions for {{ registrationUserQuestions.FirstName }} {{ registrationUserQuestions.LastName }}:</h3>
  <div *ngFor="let questionAndAnswer of registrationUserQuestions.ClubQuestionAnswer">
    <label
      >{{ questionAndAnswer.Question.Question }} <span *ngIf="questionAndAnswer.Question.IsRequired" class="pl-1">*</span></label
    >
    <div [ngSwitch]="questionAndAnswer.Question.QuestionType" class="answer mb-3">
      <!-- Dropdown -->
      <div *ngSwitchCase="questionType.DropDown">
        <select class="form-control" [(ngModel)]="answers[questionAndAnswer.Question.Id]" required>
          <option value=""></option>
          <option *ngFor="let answer of questionAndAnswer.Answer" [value]="answer.Id">
            {{ answer.Answer }}
          </option>
        </select>
      </div>

      <!-- Multiselect -->
      <div *ngSwitchCase="questionType.MultiSelect">
        <div *ngFor="let answer of questionAndAnswer.Answer" class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            [(ngModel)]="answers[questionAndAnswer.Question.Id + '__' + answer.Id]"
            [name]="answer.QuestionId"
            [value]="answer.Id"
            [id]="answer.QuestionId + '__' + answer.Id"
            required
          />
          <label class="form-check-label font-weight-normal" [for]="answer.QuestionId + '__' + answer.Id">
            {{ answer.Answer }}
          </label>
        </div>
      </div>

      <!-- Radio -->
      <div *ngSwitchCase="questionType.Radio">
        <div *ngFor="let answer of questionAndAnswer.Answer" class="form-check">
          <input
            class="form-check-input"
            type="radio"
            [(ngModel)]="answers[questionAndAnswer.Question.Id]"
            [name]="answer.QuestionId"
            [value]="answer.Id"
            [id]="answer.QuestionId + '__' + answer.Id"
            required
          />
          <label class="form-check-label font-weight-normal" [for]="answer.QuestionId + '__' + answer.Id">
            {{ answer.Answer }}
          </label>
        </div>
      </div>

      <!-- Textbox -->
      <div *ngSwitchDefault>
        <input type="text" class="form-control" [(ngModel)]="answers[questionAndAnswer.Question.Id]" required />
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="text-center">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>

<fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
